import React from 'react';

import {FmlxToggleButton} from 'fmlx-common-ui';
import PropTypes from 'prop-types';

import {MembraneTypeOptions} from '@/constants/autoProfileEnum';
import {MembraneTypeEnum} from '@/constants/dataEnum';
import {gapFixerClass} from '@/libs/styleHelper';

import './MembraneCutOffSelection.less';

function MembraneType({value, onChange, name, id, disabled}) {
  return (
    <div
      className={`membrane-cutoff-size-selection ${gapFixerClass()} div-3col center`}
      id={id}
    >
      <p>{name}</p>
      <FmlxToggleButton
        items={[
          {
            id: MembraneTypeOptions.MPES,
            text: MembraneTypeEnum.MPES,
            disabled,
          },
          {
            id: MembraneTypeOptions.RC,
            text: MembraneTypeEnum.RC,
            disabled,
          },
        ]}
        value={value}
        onChange={onChange}
        id="membrane-type-toggle-button"
      />
    </div>
  );
}

MembraneType.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
};

MembraneType.defaultProps = {
  value: null,
  onChange: () => {},
  name: '',
  id: '',
  disabled: false,
};

export default MembraneType;
